import { render, staticRenderFns } from "./MemberPracticesTab.vue?vue&type=template&id=7c392751&scoped=true"
import script from "./MemberPracticesTab.vue?vue&type=script&lang=js"
export * from "./MemberPracticesTab.vue?vue&type=script&lang=js"
import style0 from "./MemberPracticesTab.vue?vue&type=style&index=0&id=7c392751&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c392751",
  null
  
)

export default component.exports